//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Voice from './Voice.vue'

// 是否是H5渠道
let h5 = false

export default {
  name: 'm-intro',
  components: {
    [Voice.name]: Voice
  },
  data () {
    return {
      h5: h5
    }
  },
  mounted () {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }
  },
  computed: {
    showMedia () {
      if (this.h5 && !this.$store.state.h5.configuration.isNull && Number(this.$store.state.h5.configuration.homeMedia) === 0) return false
      return true
    },
    VSSrc () {
      if (this.h5 && !this.$store.state.h5.configuration.isNull) return 'static/images/channel_vs.png'
      return 'static/images/vs.png'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Intro.vue